// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Toolbar } from '@mui/material';
import theme from './theme';

// Componentes
import Header from './components/Layout/Header';
import Sidebar from './components/Layout/Sidebar';
import Login from './components/Auth/Login';
import ProductList from './components/Products/ProductList';
import ProductForm from './components/Products/ProductForm';
import UserList from './components/Users/UserList';
import UserForm from './components/Users/UserForm';
import RoleList from './components/Layout/RoleList'; // Importar RoleList
import RoleForm from './components/Layout/RoleForm'; // Importar RoleForm
import BodegaList from './components/Layout/BodegaList'; // Importar BodegaList
import MovimientoList from './components/Layout/MovimientoList'; // Importar MovimientoList
import MovimientoForm from './components/Layout/MovimientoForm'; // Asegúrate de tener este componente
import ProtectedRoute from './components/Auth/ProtectedRoute';
import Unauthorized from './components/Auth/Unauthorized';
// Importa otros componentes según sea necesario

function App() {
  const [drawerOpen, setDrawerOpen] = useState(true);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Header onDrawerToggle={handleDrawerToggle} />
        <Sidebar />
        {/* Añadir un Toolbar para empujar el contenido debajo del AppBar */}
        <Toolbar />
        <div style={{ marginLeft: drawerOpen ? 240 : 57, padding: 16 }}>
          <Routes>
            {/* Ruta de Inicio de Sesión */}
            <Route path="/login" element={<Login />} />
            <Route path="/unauthorized" element={<Unauthorized />} />

            {/* Rutas Públicas (Movimientos Accesibles sin Autenticación) */}
            <Route path="/movimientos" element={<MovimientoList />} />
            <Route path="/movimientos/new" element={<MovimientoForm />} />
            <Route path="/movimientos/edit/:id" element={<MovimientoForm />} />

            {/* Rutas Protegidas con Autenticación */}
            <Route
              path="/bodegas"
              element={
                <ProtectedRoute>
                  <BodegaList />
                </ProtectedRoute>
              }
            />

            {/* Rutas Protegidas con Permisos */}
            <Route
              path="/products"
              element={
                <ProtectedRoute requiredPermission="crearProductos">
                  <ProductList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/products/new"
              element={
                <ProtectedRoute requiredPermission="crearProductos">
                  <ProductForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/products/edit/:id"
              element={
                <ProtectedRoute requiredPermission="crearProductos">
                  <ProductForm />
                </ProtectedRoute>
              }
            />

            <Route
              path="/users"
              element={
                <ProtectedRoute requiredPermission="crearUsuarios">
                  <UserList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users/new"
              element={
                <ProtectedRoute requiredPermission="crearUsuarios">
                  <UserForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users/edit/:id"
              element={
                <ProtectedRoute requiredPermission="crearUsuarios">
                  <UserForm />
                </ProtectedRoute>
              }
            />

            <Route
              path="/roles"
              element={
                <ProtectedRoute requiredPermission="crearUsuarios">
                  <RoleList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/roles/new"
              element={
                <ProtectedRoute requiredPermission="crearUsuarios">
                  <RoleForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/roles/edit/:nombre"
              element={
                <ProtectedRoute requiredPermission="crearUsuarios">
                  <RoleForm />
                </ProtectedRoute>
              }
            />

            {/* Redireccionamiento por defecto */}
            <Route path="/" element={<Navigate to="/products" />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
